import { BaseService } from './base.service'
import $store from '@/store'

export class PaymentSchedulesService extends BaseService {
  static get entity () {
    return 'paymentSchedules'
  }

  static get listByIdUrl () {
    return 'Loan/PaymentSchedule'
  }

  static makePaymentSchedulePdf (contractNo) {
    return this.request({ auth: true, responseType: 'blob' }).get(`MakePDF/PaymentSchedulePdf/${contractNo}`)
      .then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', 'payment-schedule-contract-' + contractNo + '.pdf')
        document.body.appendChild(fileLink)

        fileLink.click()
      }).catch(error => {
        error = Object.assign({}, error)
        if (error.response.status === 404) {
          $store.commit('toast/NEW', { type: 'error', message: 'Không có tập tin' })
        } else {
          $store.commit('toast/NEW', { type: 'error', message: error.response.statusText })
        }
      })
  }
}
